import styled from "styled-components";
import { CatModel } from "../models/cat";
import { JSX, useState } from "react";
import { Modal } from "./modal";

interface CatProps {
  cat: CatModel;
}

export function CatComponent({ cat }: CatProps) {
  const [modalContent, setModalContent] = useState<JSX.Element>();

  const openPhotoModal = (imageUrl: string) =>
    setModalContent(<StyledImage src={imageUrl} alt="Fullscreen" />);

  const closeModal = () => setModalContent(undefined);

  return (
    <div>
      <CatImage
        src={cat.url}
        alt="cat"
        onClick={() => openPhotoModal(cat.url)}
      ></CatImage>
      {cat.breeds === undefined || cat.breeds.length === 0 ? (
        <></>
      ) : (
        <ContainerTag>
          {cat.breeds.map((breed) => (
            <StyledTag key={breed.id}>{breed.name}</StyledTag>
          ))}
        </ContainerTag>
      )}
      <Modal onClose={closeModal}>{modalContent}</Modal>
    </div>
  );
}

const CatImage = styled.img`
  width: 300px;
  height: 300px;
  object-fit: cover;
  border-radius: 5px;
`;

const ContainerTag = styled.ul`
  display: flex;
  flex-direction: row;
  gap: 10px;
  list-style-type: none;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
  max-width: 100%;
`;

const StyledTag = styled.li`
  background: linear-gradient(to right, #8a2be2, pink);
  color: white;
  font-size: 14px;
  font-weight: bold;
  border-radius: 15px;
  padding: 5px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const StyledImage = styled.img`
  width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
